import Link from "next/link";

export default function Contact2() {
  return (
    <section className="overflow-hidden max-w-screen w-screen pt-8 bg-center">
    <div className="bg-[#F7F8F9] max-w-screen w-screen left-0 right-0">
      <div className="flex flex-col justify-center items-center pt-16 px-16 xl:max-w-4xl lg:max-w-4xl md:max-w-3xl mx-auto text-center">
        <h2 className="mb-4 text-3xl md:text-4xl font-heading font-bold text-maingray">
          We are the CKAN experts
        </h2>
        <p className="mb-10 font-heading font-['Inter'] font-normal text-secgray ">
          Datopian are the co-creators, co-stewards and one of the main
          developers of CKAN. We design, develop and scale CKAN solutions for
          everyone from government to the Fortune 500. We also monitor client
          use cases for data to ensure that CKAN is responding to genuine
          challenges faced by real organizations.
        </p>
        
      </div>
      <div className="flex flex-col items-center md:flex-row justify-center pb-16 md:px-16 px-4 gap-4">
          <Link
            href="/contact"
            className="btn-primary"
          >
            Email us
          </Link>
          <Link
            href="https://calendar.app.google/LT4acVdKn3Cxm2MXA"
            className="btn-secondary"
          >
            Schedule a call
          </Link>
        </div>
    </div>
  </section>
  )
}
